// extracted by mini-css-extract-plugin
export default {"Hotel_available":"AllHotel_Hotel_available__ZIe1c","notAvailablehotel":"AllHotel_notAvailablehotel__qWANo","getData":"AllHotel_getData__BGfaH","devide":"AllHotel_devide__5DO1Z"};